import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnimationBehavior } from '@freelancer/directives';
import { ContainerSize } from '@freelancer/ui/container';
import { IconColor } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkHoverColor,
  LinkIconPosition,
  LinkWeight,
} from '@freelancer/ui/link';
import { TextSize } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'app-home-page-hire-categories',
  template: `
    <fl-container
      class="AnimationContainer"
      [size]="ContainerSize.DESKTOP_LARGE"
      [sizeDesktopXLarge]="ContainerSize.DESKTOP_XLARGE"
    >
      <div
        class="AnimatedLineTop"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.GROW"
        [flAnimateOnScrollDelay]="0.5"
        [flAnimateOnScrollDuration]="0.3"
      ></div>
      <div
        class="AnimatedLogo"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
        [flAnimateOnScrollDuration]="0.2"
        [flAnimateOnScrollDelay]="0.8"
      ></div>
      <div
        class="AnimatedLineBottom"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.GROW"
        [flAnimateOnScrollDelay]="0.8"
        [flAnimateOnScrollDuration]="0.5"
      ></div>
    </fl-container>
    <fl-grid
      flTrackingSection="HomePage"
      class="Container"
    >
      <fl-col
        [col]="12"
        [colDesktopSmall]="4"
      >
        <h2
          class="text-light text-title-40 HireCategories-heading tablet:text-title-50 font-bold mb-mid tablet:mb-xlarge desktop:mb-xxxxlarge"
          i18n="Hire categories blade heading"
          [flAnimateOnScroll]="true"
          [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
          [flAnimateOnScrollDuration]="0.3"
        >
          Get work done in
          <div class="Heading">over 2700</div>
          different categories
        </h2>
      </fl-col>
      <fl-col
        [col]="6"
        [colTablet]="3"
        [colDesktopSmall]="2"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
        [flAnimateOnScrollDuration]="0.3"
        [flAnimateOnScrollDelay]="0.1"
      >
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Website Design"
          [flTrackingLabel]="'HireCategories-WebsiteDesign'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/website-design'"
          [size]="TextSize.BODY_16"
        >
          Website Design
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Mobile Apps"
          [flTrackingLabel]="'HireCategories-MobilePhone'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/mobile-app-development'"
          [size]="TextSize.BODY_16"
        >
          Mobile Apps
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Android Apps"
          [flTrackingLabel]="'HireCategories-Android'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/android'"
          [size]="TextSize.BODY_16"
        >
          Android Apps
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for iPhone Apps"
          [flTrackingLabel]="'HireCategories-Iphone'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/iphone-app-development'"
          [size]="TextSize.BODY_16"
        >
          iPhone Apps
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Software Architecture"
          [flTrackingLabel]="'HireCategories-SoftwareArchitecture'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/software-architecture'"
          [size]="TextSize.BODY_16"
        >
          Software Architecture
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Graphic Design"
          [flTrackingLabel]="'HireCategories-GraphicDesign'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/graphic-design'"
          [size]="TextSize.BODY_16"
        >
          Graphic Design
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Logo Design"
          [flTrackingLabel]="'HireCategories-LogoDesign'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/logo-design'"
          [size]="TextSize.BODY_16"
        >
          Logo Design
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Public Relations"
          [flTrackingLabel]="'HireCategories-PublicRelations'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/public-relations'"
          [size]="TextSize.BODY_16"
        >
          Public Relations
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Logistics"
          [flTrackingLabel]="'HireCategories-LogisticsShipping'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/logistics-shipping'"
          [size]="TextSize.BODY_16"
        >
          Logistics
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Proofreading"
          [flTrackingLabel]="'HireCategories-Proofreading'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/proofreading'"
          [size]="TextSize.BODY_16"
        >
          Proofreading
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Translation"
          [flTrackingLabel]="'HireCategories-Translation'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/translation'"
          [size]="TextSize.BODY_16"
        >
          Translation
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Research"
          [flTrackingLabel]="'HireCategories-Research'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/research'"
          [size]="TextSize.BODY_16"
        >
          Research
        </fl-link>
      </fl-col>
      <fl-col
        [col]="6"
        [colTablet]="3"
        [colDesktopSmall]="2"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
        [flAnimateOnScrollDuration]="0.3"
        [flAnimateOnScrollDelay]="0.1"
      >
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Research Writing"
          [flTrackingLabel]="'HireCategories-ResearchWriting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/research-writing'"
          [size]="TextSize.BODY_16"
        >
          Research Writing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Article Writing"
          [flTrackingLabel]="'HireCategories-Articles'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/articles'"
          [size]="TextSize.BODY_16"
        >
          Article Writing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Web Scraping"
          [flTrackingLabel]="'HireCategories-web-scraping'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/WebScraping'"
          [size]="TextSize.BODY_16"
        >
          Web Scraping
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for HTML"
          [flTrackingLabel]="'HireCategories-HTML'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/html'"
          [size]="TextSize.BODY_16"
        >
          HTML
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for CSS"
          [flTrackingLabel]="'HireCategories-CSS'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/css'"
          [size]="TextSize.BODY_16"
        >
          CSS
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for HTML 5"
          [flTrackingLabel]="'HireCategories-HTMLFive'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/html5'"
          [size]="TextSize.BODY_16"
        >
          HTML 5
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Javascript"
          [flTrackingLabel]="'HireCategories-Javascript'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/javascript'"
          [size]="TextSize.BODY_16"
        >
          Javascript
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Data Processing"
          [flTrackingLabel]="'HireCategories-DataProcessing'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/data-processing'"
          [size]="TextSize.BODY_16"
        >
          Data Processing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Python"
          [flTrackingLabel]="'HireCategories-Python'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/python'"
          [size]="TextSize.BODY_16"
        >
          Python
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Wordpress"
          [flTrackingLabel]="'HireCategories-Wordpress'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/wordpress'"
          [size]="TextSize.BODY_16"
        >
          Wordpress
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Web Search"
          [flTrackingLabel]="'HireCategories-WebSearch'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/web-search'"
          [size]="TextSize.BODY_16"
        >
          Web Search
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid mobile:hide"
          i18n="Display name for category item for Finance"
          [flTrackingLabel]="'HireCategories-Finance'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/finance'"
          [size]="TextSize.BODY_16"
        >
          Finance
        </fl-link>
        <div class="mobile:show">
          <ng-container *ngTemplateOutlet="viewMore"></ng-container>
        </div>
      </fl-col>
      <fl-col
        class="mobile:hide"
        [col]="6"
        [colTablet]="3"
        [colDesktopSmall]="2"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
        [flAnimateOnScrollDuration]="0.3"
        [flAnimateOnScrollDelay]="0.1"
      >
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Legal"
          [flTrackingLabel]="'HireCategories-Legal'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/legal'"
          [size]="TextSize.BODY_16"
        >
          Legal
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Linux"
          [flTrackingLabel]="'HireCategories-Linux'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/linux'"
          [size]="TextSize.BODY_16"
        >
          Linux
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Manufacturing"
          [flTrackingLabel]="'HireCategories-Manufacturing'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/manufacturing'"
          [size]="TextSize.BODY_16"
        >
          Manufacturing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Data Entry"
          [flTrackingLabel]="'HireCategories-DataEntry'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/data-entry'"
          [size]="TextSize.BODY_16"
        >
          Data Entry
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Content Writing"
          [flTrackingLabel]="'HireCategories-ContentWriting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/content-writing'"
          [size]="TextSize.BODY_16"
        >
          Content Writing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Marketing"
          [flTrackingLabel]="'HireCategories-Marketing'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/marketing'"
          [size]="TextSize.BODY_16"
        >
          Marketing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Excel"
          [flTrackingLabel]="'HireCategories-Excel'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/excel'"
          [size]="TextSize.BODY_16"
        >
          Excel
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Ghostwriting"
          [flTrackingLabel]="'HireCategories-Ghostwriting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/ghostwriting'"
          [size]="TextSize.BODY_16"
        >
          Ghostwriting
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Copywriting"
          [flTrackingLabel]="'HireCategories-Copywriting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/copywriting'"
          [size]="TextSize.BODY_16"
        >
          Copywriting
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Accounting"
          [flTrackingLabel]="'HireCategories-Accounting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/accounting'"
          [size]="TextSize.BODY_16"
        >
          Accounting
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for MySQL"
          [flTrackingLabel]="'HireCategories-MySQL'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/mysql'"
          [size]="TextSize.BODY_16"
        >
          MySQL
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for C++ Programming"
          [flTrackingLabel]="'HireCategories-CPlusPlusProgramming'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/cplusplus-programming'"
          [size]="TextSize.BODY_16"
        >
          C++ Programming
        </fl-link>
      </fl-col>
      <fl-col
        class="mobile:hide"
        [col]="6"
        [colTablet]="3"
        [colDesktopSmall]="2"
        [flAnimateOnScroll]="true"
        [flAnimateOnScrollBehavior]="AnimationBehavior.FADE"
        [flAnimateOnScrollDuration]="0.3"
        [flAnimateOnScrollDelay]="0.1"
      >
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Banner Design"
          [flTrackingLabel]="'HireCategories-BannerDesign'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/banner-design'"
          [size]="TextSize.BODY_16"
        >
          Banner Design
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Illustration"
          [flTrackingLabel]="'HireCategories-Illustration'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/illustration'"
          [size]="TextSize.BODY_16"
        >
          Illustration
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Link Building"
          [flTrackingLabel]="'HireCategories-LinkBuilding'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/link-building'"
          [size]="TextSize.BODY_16"
        >
          Link Building
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for C# Programming"
          [flTrackingLabel]="'HireCategories-CSharpProgramming'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/c-sharp-programming'"
          [size]="TextSize.BODY_16"
        >
          C# Programming
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for PHP"
          [flTrackingLabel]="'HireCategories-PHP'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/php'"
          [size]="TextSize.BODY_16"
        >
          PHP
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for 3D Modelling"
          [flTrackingLabel]="'HireCategories-ThreedModelling'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/3d-modelling'"
          [size]="TextSize.BODY_16"
        >
          3D Modelling
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Photoshop"
          [flTrackingLabel]="'HireCategories-Photoshop'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/photoshop'"
          [size]="TextSize.BODY_16"
        >
          Photoshop
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Technical Writing"
          [flTrackingLabel]="'HireCategories-TechnicalWriting'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/technical-writing'"
          [size]="TextSize.BODY_16"
        >
          Technical Writing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Blogging"
          [flTrackingLabel]="'HireCategories-Blogging'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/blog'"
          [size]="TextSize.BODY_16"
        >
          Blogging
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for Internet Marketing"
          [flTrackingLabel]="'HireCategories-InternetMarketing'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/internet-marketing'"
          [size]="TextSize.BODY_16"
        >
          Internet Marketing
        </fl-link>
        <fl-link
          class="CategoryLink mb-xxsmall tablet:mb-mid"
          i18n="Display name for category item for eCommerce"
          [flTrackingLabel]="'HireCategories-eCommerce'"
          [color]="LinkColor.LIGHT"
          [link]="'/hire/ecommerce'"
          [size]="TextSize.BODY_16"
        >
          eCommerce
        </fl-link>
        <ng-template #viewMore>
          <fl-link
            class="CategoryLink mb-xxsmall tablet:mb-mid"
            i18n="Display name for category item for View more"
            [flTrackingLabel]="'HireCategories-more'"
            [color]="LinkColor.PRIMARY"
            [iconColor]="IconColor.PRIMARY"
            [iconName]="'ui-arrow-right'"
            [iconPosition]="LinkIconPosition.RIGHT"
            [hoverColor]="LinkHoverColor.PRIMARY"
            [link]="'/hire'"
            [size]="TextSize.BODY_16"
            [weight]="LinkWeight.BOLD"
          >
            View more
          </fl-link>
        </ng-template>
        <ng-container *ngTemplateOutlet="viewMore"></ng-container>
      </fl-col>
    </fl-grid>

    <div
      class="HireCategories-list mobile:hide"
      flTrackingSection="HomePage"
    ></div>
  `,
  styleUrls: ['./hire-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageHireCategoriesComponent {
  AnimationBehavior = AnimationBehavior;
  ContainerSize = ContainerSize;
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkHoverColor = LinkHoverColor;
  LinkWeight = LinkWeight;
  TextSize = TextSize;
}
